// extracted by mini-css-extract-plugin
export default {"vector":"Vector_vector__N9rHt"};